/*
  ============================================================================
  bb-tm-bundle.js — porta la scheda al bundle giusto per l'auto del cliente
  ----------------------------------------------------------------------------
  Owner:  Linea Group per BlackBoost USA

  IL PROBLEMA
  Chi compra un downpipe M177 a $1.799 non vede mai che esiste il Level 2 per
  la sua stessa auto, che contiene quel downpipe piu' l'intake. Nessuna delle
  132 schede porta ai bundle, e i bundle valgono il doppio del ticket medio.

  COME SCEGLIE LA VARIANTE
  Non ne sceglie una a caso. Prende l'auto dal garage e cerca la variante
  bundle i cui token (motore + modello, es "M177 G63") stanno tutti nei token
  di quella piattaforma (regole in DA AUTO A VARIANTE, piu' sotto). Se il
  cliente non ha ancora scelto l'auto, invita a sceglierla invece di mostrare
  un prezzo che potrebbe non essere il suo.

  COSA NON FA
  Non mostra mai uno sconto che non esiste: le varianti con compare_at_price
  minore o uguale al prezzo sono gia' escluse dal dataset (oggi e' il caso
  della Ford Raptor del Level 1, che costa piu' del suo prezzo barrato).
  Non dice che il bundle "monta": dice che e' listato per quella piattaforma.
  ============================================================================
*/
(function () {
  'use strict';

  var host = document.querySelector('[data-bb-bundle]');
  if (!host) return;

  var handle = host.getAttribute('data-handle');
  var money = host.getAttribute('data-money') || '${{amount}}';
  var url = host.getAttribute('data-bundles-url');
  if (!handle || !url) return;

  var data = null;

  function fmt(v, converted) {
    var n = Number(v);
    if (!isFinite(n)) return '';
    // bb-catalog.json ha i prezzi nella valuta del negozio (USD). Con Shopify Markets
    // attivo money_format diventa "CHF {{amount}}" ma il numero NON viene convertito:
    // senza questo il cliente svizzero legge un prezzo piu' alto del 21,6%.
    // converted = prezzo gia' nella valuta del cliente (da /products/<h>.js): niente tasso.
    var rate = 1;
    try {
      if (!converted && window.Shopify && Shopify.currency && Shopify.currency.rate) {
        rate = parseFloat(Shopify.currency.rate) || 1;
      }
    } catch (e) { rate = 1; }
    n = n * rate;
    var sep = /(\d)(?=(\d{3})+(?!\d))/g;
    var withDec = n.toFixed(2).replace(sep, '$1,');
    var noDec = Math.round(n).toString().replace(sep, '$1,');
    return money
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withDec)
      .replace(/\{\{\s*amount\s*\}\}/g, withDec);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /*
    DA AUTO A VARIANTE (1 ott 2026)
    Prima si leggeva data.platformTokens[platform.id], una tabella fatta il 19 ago
    con gli id del vecchio file di compatibilita' ("i082"). Il garage oggi usa gli
    id di bb-fitment.json ("v8ad512f"): la tabella non trovava mai l'auto e il
    riquadro spariva per qualsiasi auto scelta. Ora i token si ricavano
    dall'oggetto che BBGarage.get() restituisce, quindi il formato degli id non
    conta piu'. Regole prese da bb-bundle-finder.js, meglio rifiutare che indovinare:
      - motore: se il titolo nomina un motore (M177, M157, S58) deve essere quello
        dell'auto. M176 vale M177: stesso V8, BlackBoost chiama "M177" il kit S560.
      - modello: le parole (LAND, ROVER, BRONCO) ci vogliono tutte, dei codici
        modello (C63, GLC63, M4/M3) ne basta uno, perche' "M177 GT63 E63" e' un
        kit per due auto. Sempre token uguali, mai sottostringhe: C63 non e' GLC63.
      - trazione: le varianti RWD restano fuori come in bb-bundle-finder.liquid
        (il downpipe M157 E63/CLS63 e' solo AWD). La AWD si scarta se l'auto e'
        RWD; se la trazione non la sappiamo, lo diciamo sotto il prezzo.
  */
  var ENGINE = /^(M\d{3}|[BNS]\d{2})$/;

  /*
    COSA C'E' IN OGNI BUNDLE (dalle descrizioni dei tre prodotti, 1 ott 2026)
    Level 1 = aspirazione + BOV, Level 2 = aspirazione + downpipe, Level 3 = tutti
    e tre. Serve due volte:
      - il pezzo aperto deve essere uno dei componenti, se no la scheda di un
        termostato o di un BOV prometteva un bundle che quel pezzo non lo contiene;
      - per l'auto scelta il negozio deve avere listato un pezzo per OGNI
        componente (tipo da bb-catalog.json). Il titolo "M177 E63" copre anche la
        E63 Facelift, ma il suo downpipe e' un altro (vedi bb-fitment-overrides,
        BBCD026), e "FORD BRONCO" copre la 2.3L che ha un'altra aspirazione: li'
        si ripiega sul livello piu' basso che e' tutto listato, o si tace.
    Se arriva un bundle nuovo va aggiunto qui, altrimenti non viene proposto
    (che e' la direzione sicura).
  */
  var ROLES = {
    'bundle-1-essential': { intake: 1, bov: 1 },
    'level-2-performance-bundle': { intake: 1, downpipe: 1 },
    'level-3-elite-performance-bundle': { intake: 1, downpipe: 1, bov: 1 }
  };
  var TYPE_ROLE = { INTAKE: 'intake', DOWNPIPES: 'downpipe', ADAPTER: 'bov' };
  var role = null;
  var cat = {};
  var anyCache = null;
  var painted = 0;
  var live = {};

  function words(s) {
    return String(s == null ? '' : s).toUpperCase().split(/[^A-Z0-9]+/).filter(Boolean);
  }
  function isCode(w) {
    return /\d/.test(w) && /^[A-Z]{0,4}\d{1,4}[A-Z]?$/.test(w);
  }

  function rule(title) {
    var raw = String(title || '').toUpperCase();
    var r = { engine: '', req: [], alt: [], awd: /\bAWD\b/.test(raw), rwd: /\bRWD\b/.test(raw) };
    var list = raw.split(/\s+/);
    for (var i = 0; i < list.length; i++) {
      var w = list[i].replace(/[^A-Z0-9\/]/g, '');
      if (!w) continue;
      if (!r.engine && ENGINE.test(w)) { r.engine = w; continue; }
      if (w === 'AWD' || w === 'RWD') continue;
      var parts = w.split('/').filter(Boolean), codes = true;
      for (var p = 0; p < parts.length; p++) if (!isCode(parts[p])) codes = false;
      if (codes) r.alt = r.alt.concat(parts);
      else r.req.push(parts);
    }
    return r;
  }

  function carTokens(platform) {
    var list = words(platform.make).concat(words(platform.model), words((platform.chassis || []).join(' ')));
    var set = {};
    for (var i = 0; i < list.length; i++) {
      set[list[i]] = true;
      // E63S risponde anche a E63; si aggiunge solo la forma corta, GLC63 non diventa C63
      if (/^[A-Z]*\d{2,3}S$/.test(list[i])) set[list[i].slice(0, -1)] = true;
    }
    return set;
  }

  function carEngine(platform) {
    var list = words(platform.engine);
    for (var i = 0; i < list.length; i++) {
      if (ENGINE.test(list[i])) return list[i] === 'M176' ? 'M177' : list[i];
    }
    return '';
  }

  function fitsRule(r, tokens, engine) {
    if (r.rwd) return false;
    if (!r.engine && !r.req.length && !r.alt.length) return false;
    if (r.engine && r.engine !== engine) return false;
    for (var i = 0; i < r.req.length; i++) {
      var hit = false;
      for (var j = 0; j < r.req[i].length; j++) if (tokens[r.req[i][j]]) hit = true;
      if (!hit) return false;
    }
    if (r.alt.length) {
      var any = false;
      for (var k = 0; k < r.alt.length; k++) if (tokens[r.alt[k]]) any = true;
      if (!any) return false;
    }
    if (r.awd && tokens.RWD) return false;
    return true;
  }

  // Componenti che il negozio vende per quest'auto: tipi dei pezzi listati per lei.
  function carRoles(platform) {
    var g = window.BBGarage, out = {};
    var handles = (g && g.productsFor && g.productsFor(platform.id)) || [];
    for (var i = 0; i < handles.length; i++) {
      var c = cat[handles[i]];
      var r = c && TYPE_ROLE[String(c.y || '').toUpperCase()];
      if (r) out[r] = true;
    }
    return out;
  }

  function best(platform) {
    if (!platform || !role) return null;
    var tokens = carTokens(platform), engine = carEngine(platform), has = carRoles(platform);
    var found = null;
    for (var b = 0; b < data.bundles.length; b++) {
      var bundle = data.bundles[b], parts = ROLES[bundle.h], complete = !!parts;
      if (!parts || !parts[role]) continue;
      for (var need in parts) if (!has[need]) complete = false;
      if (!complete) continue;
      for (var v = 0; v < bundle.v.length; v++) {
        var variant = bundle.v[v];
        var r = variant.rule || (variant.rule = rule(variant.t));
        if (!fitsRule(r, tokens, engine)) continue;
        if (!found || bundle.r > found.rank || (bundle.r === found.rank && variant.p < found.variant.p)) {
          found = { rank: bundle.r, bundle: bundle, variant: variant, awd: r.awd };
        }
      }
    }
    return found;
  }

  // L'invito "scegli l'auto" solo se almeno un'auto di questo pezzo ha un bundle
  // che lo contiene: su un downpipe Ferrari era una promessa senza seguito.
  function anyBundle(g) {
    if (anyCache !== null) return anyCache;
    var ids = (g.data && g.data.products && g.data.products[handle]) || [];
    anyCache = false;
    for (var i = 0; i < ids.length && !anyCache; i++) {
      if (best(g.platform(ids[i]))) anyCache = true;
    }
    return anyCache;
  }

  /*
    PREZZO VERO DEL BUNDLE (1 ott 2026)
    bb-bundles.json e' del 19 ago e da allora 18 varianti su 42 hanno cambiato
    prezzo (Level 3 M177 E63: file $3,429.36, negozio $3,464.56): il riquadro
    prometteva un prezzo che la scheda del bundle smentiva. Dal file si prende solo
    QUALE variante; prezzo, prezzo barrato e disponibilita' si chiedono al negozio.
    Con i cookie (same-origin) arriva gia' nella valuta e con gli arrotondamenti
    del cliente, quindi fmt non riapplica il tasso. Se la risposta non arriva o la
    variante e' esaurita si tace, invece di mostrare un prezzo forse sbagliato.
  */
  function liveVariant(h, id) {
    if (!live[h]) {
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      live[h] = fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      live[h].catch(function () { delete live[h]; });
    }
    return live[h].then(function (p) {
      var list = (p && p.variants) || [];
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    });
  }

  function paint() {
    var seq = ++painted;
    var g = window.BBGarage;
    var platform = g && g.get ? g.get() : null;
    var body = host.querySelector('[data-bb-bundle-body]');

    if (data.eligible.indexOf(handle) === -1) { host.hidden = true; return; }
    if (!role || !g || !g.data || !g.platform) { host.hidden = true; return; }

    if (!platform) {
      if (!anyBundle(g)) { host.hidden = true; return; }
      body.innerHTML =
        '<p class="bb-tm-bun__p">This part is also sold inside a bundle with the other pieces ' +
        'for the same engine. Pick your car to see the bundle and the price for it.</p>' +
        '<button type="button" class="bb-tm__btn bb-tm__btn--ghost" data-bb-open-picker>Pick your car</button>';
      host.hidden = false;
      return;
    }

    // Il pezzo deve essere listato per quest'auto, come in bb-tm-kit.js: se non lo e'
    // "questo pezzo e' nel bundle per la tua auto" sarebbe falso (1 ott 2026).
    if (!g.fits || g.fits(handle) !== 'green') { host.hidden = true; return; }

    var hit = best(platform);
    if (!hit) { host.hidden = true; return; }

    liveVariant(hit.bundle.h, hit.variant.id).then(function (lv) {
      if (seq !== painted) return; // nel frattempo il cliente ha cambiato auto
      if (!lv || lv.available === false) { host.hidden = true; return; }
      render(platform, hit, lv.price / 100, lv.compare_at_price > lv.price ? lv.compare_at_price / 100 : 0);
    }, function () {
      if (seq === painted) host.hidden = true;
    });
  }

  function render(platform, hit, price, was) {
    var body = host.querySelector('[data-bb-bundle-body]');
    var saving = was ? was - price : 0;
    body.innerHTML =
      '<p class="bb-tm-bun__p">This part is included in the <strong>' + esc(hit.bundle.l) +
      '</strong> bundle listed for your ' + esc(platform.display) + '.</p>' +
      '<p class="bb-tm-bun__price">' +
        '<span class="bb-tm-bun__now">' + fmt(price, true) + '</span>' +
        (was ? '<span class="bb-tm-bun__was">' + fmt(was, true) + '</span>' : '') +
        (saving > 0 ? '<span class="bb-tm-bun__save">Save ' + fmt(saving, true) + '</span>' : '') +
      '</p>' +
      '<a class="bb-tm__btn" href="/products/' + esc(hit.bundle.h) + '?variant=' + esc(hit.variant.id) + '">' +
        'See the ' + esc(hit.bundle.l) + ' bundle</a>' +
      '<p class="bb-tm-bun__fine">Bundle option: ' + esc(hit.variant.t) +
        // la trazione dall'auto scelta non si legge: chi ha una RWD deve saperlo prima
        (hit.awd ? '. For AWD cars only, check yours before you order.' : '') + '</p>';
    host.hidden = false;
  }

  // Il catalogo (tipi dei pezzi) e' lo stesso file che legge bb-tm-kit: stesso
  // indirizzo, cosi' il browser lo scarica una volta sola.
  var kit = document.querySelector('[data-bb-kit][data-catalog-url]');
  var catUrl = (kit && kit.getAttribute('data-catalog-url')) ||
    url.split('?')[0].replace(/bb-bundles\.json$/, 'bb-catalog.json');

  // Si dipinge solo col dataset del garage caricato: serve per sapere su quali auto
  // va il pezzo, e prima chi l'auto l'aveva gia' scelta vedeva per un attimo l'invito.
  Promise.all([
    fetch(url, { credentials: 'omit' }).then(function (r) { return r.json(); }),
    fetch(catUrl, { credentials: 'omit' }).then(function (r) { return r.json(); })
  ])
    .then(function (res) {
      data = res[0];
      cat = (res[1] && res[1].products) || {};
      role = cat[handle] ? TYPE_ROLE[String(cat[handle].y || '').toUpperCase()] || null : null;
      var g = window.BBGarage;
      return g && g.ready ? g.ready() : null;
    })
    .then(function () {
      paint();
      if (window.BBGarage && window.BBGarage.subscribe) window.BBGarage.subscribe(paint);
    })
    .catch(function () { host.hidden = true; });
})();
